import React from "react";
import { Appointment } from "@scrile/api-provider/dist/api/AppointmentProvider";
import BaseButton from "../../../../../../components/BaseButton";
import useCustomDomain from "../../../../../../hooks/useCustomDomain";
import { useTranslation } from "../../../../../../locales";
import AppointmentItem from "../AppointmentItem";
import "./style.scss";

interface Props {
  className?: string;
  appointments: Appointment[];
  isCoach?: boolean;
  onCancelSuccess: () => void;
  almostStartedAppointmentId?: Appointment["id"];
  hideStatus?: boolean;
}

export default function AppointmentList({
  className,
  appointments,
  almostStartedAppointmentId,
  isCoach = true,
  onCancelSuccess,
  hideStatus,
}: Props) {
  const { t } = useTranslation();
  const { isCustomDomain } = useCustomDomain();

  const cls = ["appointments-list"];
  if (className) cls.push(className);
  if (appointments.length === 0) cls.push("__empty");
  if (appointments.length % 2) cls.push("__hide-mobile-border");

  return (
    <div className={cls.join(" ")}>
      <div className="appointments-list__heading mb-6 label">
        <div className="appointments-list__heading-date">{t("Date")}</div>
        <div className="appointments-list__heading-time">{t("Time / Duration")}</div>
        <div className="appointments-list__heading-customer">{isCoach ? t("Customer") : t("Consultant")}</div>
        {!hideStatus && <div className="appointments-list__heading-status">{t("Status")}</div>}
      </div>
      {appointments.length === 0 && (
        <div className="d-flex __column __align-center">
          <div className="appointments-list__empty-content d-center mb-6">{t("You currently have no events")}</div>
          {!isCoach && !isCustomDomain && (
            <BaseButton large to="/coaches">
              {t("Find a Consultant")}
            </BaseButton>
          )}
        </div>
      )}
      {appointments.map((appointment) => {
        return (
          <AppointmentItem
            key={appointment.id}
            appointment={appointment}
            isCoach={isCoach}
            onCancelSuccess={onCancelSuccess}
            isAlmostMeetingStart={almostStartedAppointmentId === appointment.id}
          />
        );
      })}
    </div>
  );
}
